import { createSvgIcon } from '@material-ui/core';

export const DisabledIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2098_1175)">
      <path
        d="M37.7886 9.78859C35.0615 7.06146 31.5869 5.20427 27.8043 4.45186C24.0216 3.69944 20.1008 4.08561 16.5377 5.56152C12.9745 7.03743 9.92904 9.53679 7.78635 12.7436C5.64366 15.9503 4.50001 19.7204 4.50001 23.5772C4.50001 27.4339 5.64367 31.204 7.78635 34.4108C9.92904 37.6175 12.9745 40.1169 16.5377 41.5928C20.1008 43.0687 24.0216 43.4549 27.8043 42.7025C31.5869 41.9501 35.0615 40.0929 37.7886 37.3657C41.444 33.708 43.4974 28.7484 43.4974 23.5772C43.4974 18.406 41.444 13.4464 37.7886 9.78859ZM29.5152 31.8505L24.0033 26.3386L18.4914 31.8505L15.7355 29.0946L21.2474 23.5827L15.7355 18.0708L18.4914 15.3148L24.0033 20.8267L29.5152 15.3148L32.2712 18.0708L26.7593 23.5827L32.2712 29.0946L29.5152 31.8505Z"
        fill="#90A4AE"
      />
    </g>
    <defs>
      <clipPath id="clip0_2098_1175">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'DisabledIcon',
);
